var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoomloader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.1,
    y: 10.6,
    style: {
      fill: "#000"
    },
    width: 2.4,
    height: 2.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8,19.1c-0.3,0-0.5,0.2-0.5,0.4c0,0,0,0,0,0.1c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.4,0.1 s0.3,0,0.4-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0,0,0-0.1,0-0.1C18.3,19.3,18.1,19.1,17.8,19.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8,19.3c-0.1-0.1-0.3-0.2-0.4-0.2S3,19.2,2.9,19.3c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1 c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0,0,0-0.1,0-0.1 C3.8,19.5,3.8,19.4,3.8,19.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.1,17.6c0,0.3,0,0.6,0,0.8c0.5,0,1,0,1.5,0c0-0.3,0-0.6,0-0.8C21.1,17.6,20.6,17.6,20.1,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.8,17.8c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8C19.7,18.6,18.8,17.8,17.8,17.8z  M18.2,20c-0.1,0.1-0.2,0.1-0.4,0.1s-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1c0-0.3,0.3-0.4,0.5-0.4 s0.5,0.2,0.5,0.4c0,0,0,0,0,0.1C18.4,19.8,18.3,19.9,18.2,20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3.3,17.8L3.3,17.8c-0.9,0-1.7,0.7-1.8,1.5c0,0.1,0,0.2,0,0.3c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8 c0-0.1,0-0.2,0-0.3C5,18.4,4.2,17.8,3.3,17.8z M3.7,20c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.3,0-0.4-0.1c-0.2-0.1-0.2-0.2-0.2-0.4 c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.3-0.2,0.4-0.2s0.4,0.1,0.4,0.2c0,0,0.1,0.1,0.1,0.2c0,0,0,0,0,0.1 C3.9,19.8,3.8,19.9,3.7,20z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6,17.8H1.1v1.5h0.3l0,0C1.5,18.6,2,18,2.6,17.8z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.1,17.6c0,0.3,0,0.6,0,0.8c0.5,0,1,0,1.5,0c0-0.3,0-0.6,0-0.8C21.1,17.6,20.6,17.6,20.1,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.1,12.6c0,0.8,0,1.6,0,2.5c0.8,0,1.6,0,2.3,0c-0.2-0.8-0.5-1.6-0.7-2.4C18.2,12.6,17.7,12.6,17.1,12.6z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6,18.4c0-0.8,0-1.7,0-2.5c-0.3-0.1-0.5-0.3-0.8-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c0,0,0,0-0.1,0 c-0.4-0.2-0.4-0.7-0.5-1.1c-0.1-0.6-0.4-1.2-0.6-1.8l0,0h-3.4v0.2l0,0c0,1.8,0,3.6,0,5.4H3.9c0.7,0.2,1.1,0.8,1.3,1.5l0,0h10.5 c0.3-0.8,0.9-1.7,1.9-1.7c1.1-0.1,2.1,0.7,2.3,1.7c0.7,0,1.4,0,2.1,0c0-0.3,0-0.6,0-0.9C21.9,18.4,21.8,18.4,21.6,18.4z  M17.1,15.1c0-0.8,0-1.6,0-2.5c0.5,0,1.1,0,1.6,0c0.2,0.8,0.5,1.6,0.7,2.4C18.7,15.1,17.9,15.1,17.1,15.1z M21.5,18.4 c-0.5,0-1,0-1.5,0c0-0.3,0-0.6,0-0.8c0.5,0,1,0,1.4,0C21.5,17.9,21.5,18.1,21.5,18.4z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,7.2L21.2,7.2c0-0.2,0.1-0.3,0.3-0.4l0,0h0.4c0.1,0,0.2-0.1,0.2-0.2l0.2-1c0,0,0,0,0,0H23l-0.4-3.2 L10,10.6H5.9v2.6H1v4h3v0.4h7v-2.2l3.7-3.6l6.6-6.2l0,0l0.1,1v0C21.2,6.8,21,7,21,7.3c0,0,0,0.1,0,0.2v0l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0.2,0.2,0.3,0.2l0,0h0l0,0c0,0,0.1,0,0.2,0l0,0l0,0c0.1,0,0.2,0,0.3,0l0,0c0.1,0,0.2-0.1,0.3-0.3 c0-0.1,0.1-0.2,0.1-0.3l0,0h-0.2l0,0c0,0,0,0.1,0,0.1l0,0c0,0,0,0,0,0l0,0c-0.1,0.2-0.3,0.3-0.3,0.3l0,0c0,0-0.1,0-0.1,0 s-0.1,0-0.1,0l0,0l0,0c-0.1,0-0.2-0.1-0.3-0.2l0,0l0,0l0,0C21.2,7.4,21.2,7.4,21.2,7.2L21.2,7.2L21.2,7.2z M1.8,16.8H1.4v-3.2h0.4 V16.8z M2.8,16.8H2.4v-3.2h0.4V16.8z M3.8,16.8H3.3v-3.2h0.4V16.8z M6.3,14.1V11h3.4l0.9,3.1H6.3z M11,15v-0.7l-0.7-2.4h3.8L11,15z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoomloader);
export default __webpack_public_path__ + "static/media/boomloader.3f168ea33834562e7c2cbc3387e02983.svg";
export { ForwardRef as ReactComponent };